import { createFileRoute, Outlet } from "@tanstack/react-router";

import { InShellNotFound } from "../../components/auth/InShellNotFound";
import { InsufficientRoleView } from "../../components/auth/InsufficientRoleView";
import { useViewerRoles } from "../../components/auth/ViewerRolesContext";

export const Route = createFileRoute("/_authed/super")({
  component: SuperLayout,
  notFoundComponent: InShellNotFound,
});

function SuperLayout() {
  const { isSuperadmin } = useViewerRoles();

  if (!isSuperadmin) {
    return (
      <InsufficientRoleView description="This area is for Inference superadmins only." />
    );
  }

  return <Outlet />;
}
